module.exports = __webpack_public_path__ + "img/juillet25_mobile_upgrade_banner.6041da7b.png";